import React, { useState, useEffect } from "react";
import { Col, Container, Form, Image, Row, Button } from "react-bootstrap";
import logo_signin from "../assets/images/logo_signin.png";
import Checkbox from "@mui/material/Checkbox";
import { useHistory } from "react-router";
import { URL, apiHeader, firebaseVapidObject } from "../Config/apiUrl";
import { Post } from "../Axios/AxiosFunctions";
import { Link } from "react-router-dom";
import { saveLoginUserData } from "../store/Actions/authAction";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import firebase, { messaging } from "../firebase";

const Signin = ({ setfooterStyle }) => {
  const history = useHistory();

  history.location.pathname ? setfooterStyle(true) : setfooterStyle(false);
  const dispatch = useDispatch();

  const [inputData, setInputData] = React.useState({
    email: "",
    password: "",
  });
  const [myFCMToken, setMyFCMToken] = useState("");
  const [checked, setChecked] = React.useState(false);
  const [responsible, setResponsible] = React.useState("");
  const [userData, setUserData] = React.useState([]);
  const [isApiCall, setIsApiCall] = useState(false);

  // If firebase supported, take out token and send to server
  useEffect(() => {
    const getToken = async () => {
      let token = "";
      if (firebase.messaging.isSupported()) {
        token = await messaging.getToken(firebaseVapidObject);
        setMyFCMToken(token);
      }
    };

    getToken();
  }, []);

  const handleChangeValue = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };

  const handleChange = (event) => {
    const { name } = event.target;
    setChecked({ ...checked, [event.target.name]: event.target.checked });
  };

  // login api
  const handleSubmit = async (e) => {
    const url = URL(`general/login`);
    e.preventDefault();
    const params = { ...inputData };

    for (let key in params) {
      if (params[key] == "") {
        return toast.warn(`${key} can not be empty.`);
      }
    }

    params.fcmToken = myFCMToken;

    setIsApiCall(true);
    const response = await Post(url, params, apiHeader());
    setIsApiCall(false);
    if (response != undefined) {
      console.log(response?.data?.data?.user?.UserId?.role);
      dispatch(saveLoginUserData(response?.data?.data));
      if (response?.data?.data?.user?.UserId?.role == "company") {
        history.replace("/dashboard");
      } else {
        history.replace("/profile");
      }
    }
  };

  return (
    <div className="signin_bg_pic">
      <Container className="Signin_Main">
        <form onSubmit={handleSubmit}>
          <Row>
            <Col>
              <div className="text-center mb-5">
                <Image src={logo_signin} />
              </div>

              <div>
                <Form.Control
                  id="floatingInputCustom"
                  type="email"
                  name="email"
                  value={inputData.email}
                  required
                  onChange={handleChangeValue}
                  placeholder="Email Address"
                  className="mb-3"
                />
                <Form.Control
                  id="floatingInputCustom"
                  type="password"
                  name="password"
                  required
                  value={inputData.password}
                  onChange={handleChangeValue}
                  placeholder="Password"
                  className="mb-3"
                />
              </div>
            </Col>
          </Row>

          <Row>
            <Col className="d-flex j-between">
              {/* <div className="d-flex">
                <Checkbox
                  checked={checked}
                  name="closeToYou"
                  onChange={handleChange}
                  inputProps={{ "aria-label": "controlled" }}
                />
                <p className="d-flex a-center" style={{ margin: 0 }}>
                  Remember Me
                </p>
              </div> */}
              <div
                className="d-flex a-center"
                onClick={() => history.push("/forgot-password")}
              >
                <p className="d-flex a-center c-p" style={{ margin: 0 }}>
                  Forgot Password?
                </p>
              </div>
            </Col>
          </Row>
          <Row className="mt-4">
            <Button
              type="submit"
              style={{
                width: "99%",
                margin: "auto",
              }}
              disabled={isApiCall}
            >
              {isApiCall ? "Please wait..." : "Sign in"}
            </Button>
          </Row>

          <Row className="text-center mt-4">
            <Col className="alreadyAccountContainer">
              <p>Don't have an account? </p>
              <Link to="/signup">Sign Up</Link>
            </Col>
          </Row>
          <Row className=" mt-4">
            <Col>
              <p>
                By signing in to your account, you agree to JOBSTER Terms of
                Services and <br /> consent to our Cookie Policy and Privacy
                Policy .
              </p>
            </Col>
          </Row>
        </form>
      </Container>
    </div>
  );
};

export default Signin;
